import { UserCommunication } from '@this+that/models';

import { ShortcutContext } from './types';
import { useEmailListNavigation } from './useEmailListNavigation';

interface UseInboxNavigationProps {
  filteredCommunications: UserCommunication[];
}

export function useInboxNavigation({
  filteredCommunications,
}: UseInboxNavigationProps) {
  return useEmailListNavigation({
    filteredCommunications,
    context: ShortcutContext.INBOX_LIST,
  });
}
